export const DS = {
  NONE: 'NONE',
  PORTRAIT: 'PORTRAIT',
  LANDSCAPE: 'LANDSCAPE',
};

export const VS = {
  DEFAULT: 'DEFAULT',
};
